import Glide from '@glidejs/glide';

document.addEventListener( 'DOMContentLoaded', function () {
	const testimonialsElement = document.querySelector(
		'.testimonials .glide'
	);

	if ( testimonialsElement ) {
		new Glide( testimonialsElement, {
			type: 'carousel',
			perView: 1,
			autoplay: 5000,
			animationDuration: 800,
			gap: 0,
			hoverpause: true,
		} ).mount();
	}
} );
